/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Window_Resize_LeftInputs */

const en_window_resize_left = /** @type {(inputs: Window_Resize_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize from left edge`)
};

const ar_window_resize_left = /** @type {(inputs: Window_Resize_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير الحجم من الحافة اليسرى`)
};

const bn_window_resize_left = /** @type {(inputs: Window_Resize_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বামের কিনারা থেকে রিসাইজ করুন`)
};

const de_window_resize_left = /** @type {(inputs: Window_Resize_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe vom linken Rand ändern`)
};

const es_window_resize_left = /** @type {(inputs: Window_Resize_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar tamaño desde el borde izquierdo`)
};

const fr_window_resize_left = /** @type {(inputs: Window_Resize_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionner à partir du bord gauche`)
};

const pt_window_resize_left = /** @type {(inputs: Window_Resize_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionar a partir da borda esquerda`)
};

const zh_window_resize_left = /** @type {(inputs: Window_Resize_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从左边缘调整大小`)
};

const tr_window_resize_left = /** @type {(inputs: Window_Resize_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sol kenardan yeniden boyutlandır`)
};

const ru_window_resize_left = /** @type {(inputs: Window_Resize_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение размера от левого края`)
};

const pl_window_resize_left = /** @type {(inputs: Window_Resize_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień rozmiar od lewej krawędzi`)
};

/**
* | output |
* | --- |
* | "Resize from left edge" |
*
* @param {Window_Resize_LeftInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const window_resize_left = /** @type {((inputs?: Window_Resize_LeftInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Window_Resize_LeftInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_window_resize_left(inputs)
	if (locale === "bn") return bn_window_resize_left(inputs)
	if (locale === "de") return de_window_resize_left(inputs)
	if (locale === "es") return es_window_resize_left(inputs)
	if (locale === "fr") return fr_window_resize_left(inputs)
	if (locale === "pt") return pt_window_resize_left(inputs)
	if (locale === "zh") return zh_window_resize_left(inputs)
	if (locale === "tr") return tr_window_resize_left(inputs)
	if (locale === "ru") return ru_window_resize_left(inputs)
	if (locale === "pl") return pl_window_resize_left(inputs)
	return en_window_resize_left(inputs)
});